import { useTranslation } from 'react-i18next';

export type TimelineEntry = { year: string; title: string; body: string; current?: boolean };

const CURRENT_TIMELINE_INDEX = 3;

export function useTimeline(): TimelineEntry[] {
  const { t } = useTranslation();
  const items = t('about.timeline', { returnObjects: true }) as TimelineEntry[];
  return items.map((entry, i) =>
    i === CURRENT_TIMELINE_INDEX ? { ...entry, current: true } : entry,
  );
}

export type PhilosophiePillar = { n: string; title: string; body: string };

export function usePhilosophie(): PhilosophiePillar[] {
  const { t } = useTranslation();
  return t('about.philosophie.items', { returnObjects: true }) as PhilosophiePillar[];
}

export type Stat = { label: string; value: string };

export function useAboutStats(): Stat[] {
  const { t } = useTranslation();
  return t('about.stats', { returnObjects: true }) as Stat[];
}

export type Verein = {
  title: string;
  body: string;
  membership: { price: string; note: string; url: string };
};

const VEREIN_URL = 'https://brazilian-zouk.ch';

export function useVerein(): Verein {
  const { t } = useTranslation();
  return {
    title: t('about.verein.data.title'),
    body: t('about.verein.data.body'),
    membership: {
      price: t('about.verein.data.membershipPrice'),
      note: t('about.verein.data.membershipNote'),
      url: VEREIN_URL,
    },
  };
}
